import { SUPPORT_LANGS, OLD_LANGS } from '@constants/langs';
import { IS_SERVER } from '@constants';

export const detectLanguageAndRedirect = ({ router, ctx }) => {
  const { locale } = router;

  // Редирект на /en/
  if (OLD_LANGS.includes(locale)) {
    if (IS_SERVER) {
      ctx.res.writeHead(301, {
        Location: '/en/',
      });
      ctx.res.end();
    } else {
      router.push('/', '/', { locale: 'en' });
    }

    return;
  }

  if (ctx.pathname === '/') return;

  // urls with _ at the start should be next internal urls
  if (
    (SUPPORT_LANGS.some((l) => l.value === locale) && locale !== 'default') ||
    locale.indexOf('_') === 0 ||
    locale === '[...path]'
  )
    return;

  if (IS_SERVER) {
    ctx.res.statusCode = 404;
  } else {
    // redirect('_error');
  }
};
